<mat-grid-list cols="3" rowHeight="3:1">
    <mat-grid-tile *ngFor="let title of cardTitles">
        <button mat-button class="cardComplain" (click)=goTo()>{{ title }}</button>
    </mat-grid-tile>
</mat-grid-list>